export default __webpack_public_path__ + "locales/pt-BR/DeleteThirdPartyDialog.json?hash=383811f3d5ec4dd03fe921dcb814166b";